import React, { useEffect } from "react";
import PageIntro from "../../Components/PageIntro/PageIntro";
import "./Admission.css";

export default function Admission() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
  return (
    <div className="admission">
      <PageIntro
        image={require("../../Assets/teachers_office.jpeg").default}
        text={"Admission Guideline"}
      />
      <div className="container">
        <div className="mb1">
          <h1>Admission Procedure</h1>
          <ol>
            <li>
              Fill in an online application form or download an application form
              from our website and fill it. The form must be submitted with the
              original birth certificate, utility bill and £35 registration fee
            </li>
            <li>
              All Applicants will be required to take an entrance examination to
              secure a place at the school (as well as a place being available).
            </li>
            <li>
              You will be asked to make payment for the first two months' fee
              before your child's place is confirmed
            </li>
            <li>
              A letter of acceptance will be sent out to you along with a school
              starter pack.
            </li>
          </ol>
          <p className="mt05" style={{ color: "red" }}>
            Once the letter of acceptance has been issued you MUST give the
            school one term's notice to remove your child from the school. Not
            giving the required amount of notice will result in you having to
            forfeit the first two months' fee
          </p>
        </div>
        <div>
          <h1>Admission Policy</h1>
          <div>
            <p>
              Madani School And College is fully committed to equal
              opportunities in education. No applicant to Madani School And
              College should be discriminated against on the basis of race,
              nationality, colour or ethnic origin.
            </p>
            <p>
              Parents complete an online application form for entry, which can
              be obtained from the school website (
              www.madanischoolandcollege.com ) or from the school office. This
              is returned to the School Administrator with a fee of £35.00. The
              building constraints of the school limit the intake to single
              entry with a maximum of sixteen pupils per class, and therefore,
              the order in which applications are received is relevant when
              offers of places are being considered.
            </p>

            <p>
              Reports from a school currently attended by an applicant are not
              always available and thus do not form part of the selection
              procedure.
            </p>
            <p>
              Siblings are given priority if a sibling achieves exactly the same
              mark as an applicant who does not have a brother/sister in school
              then the sibling will be awarded the place.
            </p>
            <p>
              Offers are made on the basis of merit order related to the
              applicant's performance in the Entrance Examination. Applicants
              for places in Reception and Key Stage 1 are not required to take
              an examination, however, the parents will be asked to come in for
              an interview with the Primary head teacher.
            </p>
            <p>
              A reserve list will be held and all applicants on the list are
              considered to have qualified for entry to Madani School And
              College should a vacancy become available.
            </p>

            <p>
              Some applicants may not achieve a satisfactory standard and places
              will not be offered.
            </p>
            <p>
              Year 6 pupils of Al-Khair are expected to take the Entrance
              Examination although places may be allocated to them on the basis
              of their work in the Primary School.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
